<template>
  <div id="app">
    <vue-snotify/>
    <component :is="layout">
      <router-view/>
    </component>
    <SvgIcons />
  </div>
</template>

<script>
  import 'bootstrap/dist/css/bootstrap.css'

  import HomeLayout from './layouts/HomeLayout'
  import DefaultLayout from './layouts/DefaultLayout'
  import SvgIcons from './components/SvgIcons'

  export default {
    data() {
      return {
        title: this.$t('title')
      }
    },
    computed: {
      layout() {
        return (this.$route.meta.layout || 'home-layout')
      }
    },
    components: {
      HomeLayout, DefaultLayout, SvgIcons
    },
    created() {

    }
  }
</script>

<style>
  @import 'assets/css/style.css';
</style>
